// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"movie-clapper"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 9L21 9L21 21L3 21C3 17 3 13 3 9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M3 3L21 3V9L3 9C3 7 3 5 3 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 3H21M3 3C3 9 3 15 3 21H21V3M3 3C3 5 3 7 3 9H21V3M6.41667 3.5L10.5833 8.5M13.4167 3.5L17.5833 8.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 13H14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-movie-clapper')
export default class MovieClapperIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'movie-clapper',
    }
  }
}
